module.exports = __webpack_public_path__ + "img/illust-05.5ed9830b.png";